// ============================================================================
// Étanchéité des régies publicitaires sur les profils NON qualifiés.
//
//   Règle produit : un lead en recherche d'emploi ou étudiant reste le bienvenu
//   à la masterclass — on lui donne le lien — mais AUCUNE information le
//   concernant ne part vers Meta ou Google Ads. Deux raisons :
//     • ne pas entraîner l'algorithme à aller chercher davantage ce profil ;
//     • ne pas l'embarquer dans les audiences de retargeting.
//
//   PostHog, lui, reçoit tout : on a besoin de mesurer le taux de
//   disqualification et de comparer les funnels.
//
//   Ce module ne dépend de rien pour rester importable partout (analytics.ts
//   comme meta-capi.ts) sans créer de cycle.
// ============================================================================

/** Routes de sortie « hors cible » : rien ne part aux régies depuis ces pages. */
export const AD_MUTED_PATHS = ["/nok", "/mc/hc"];

/** true si la page courante est une sortie hors cible. */
export function isAdTrackingMuted(): boolean {
  if (typeof window === "undefined") return false;
  return AD_MUTED_PATHS.some((p) => window.location.pathname.startsWith(p));
}
